import React = require('react');
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../../../../components/FieldFormControl';
import { isNotFalse, isRequired } from '../../../../../../../../../../util/validators';
import * as Commonmark from 'react-commonmark';

export const MTADeclarationContent = () => {

  const popoverClickRootClose = (
    <Popover id="popover-trigger-click-root-close">
      <Commonmark
        source={'**Are a permanent UK resident**\n\n You have your only or main home in the UK and have not spent more than six months outside the UK in the year before taking out (or renewing) this policy.'}
      />
    </Popover>
  );

  return (
    <div className="mta-content-container">
      <div>
        <div className={'mta-declaration-body-text'}>
          Please check these important statements about the travellers and trips.
        </div>

        <p>All named travellers:</p>

        <ul className="declaration">
          <li className="declaration-list">are permanent UK resident
            <OverlayTrigger
              trigger="click"
              rootClose={true}
              placement="bottom"
              overlay={popoverClickRootClose}
            ><FaInfoCircle className="info-btn dark_blue"/>
            </OverlayTrigger></li>
          <li className="declaration-list">are registered with a GP in the UK</li>
          <li className="declaration-list">are unaware of any reason why a planned trip will be cut short or
            cancelled
          </li>
          <li className="declaration-list">are not currently travelling</li>
          <li className="declaration-list">will depart from, and return to, the UK</li>
        </ul>

        <p>Are all of these statements true?</p>

        <div className={'mb-15'}>
          <div className="radio-horizontal">
            <Field
              name="coverDetailsDeclaration"
              id="cover-details-declaration"
              type="checkbox"
              component={FieldFormControl}
              validate={[
                isRequired,
                isNotFalse,
              ]}
            >
              <div/>
              Tick here to agree
            </Field>
          </div>
        </div>

        <div>
          <p>
            If you are unable to confirm any of the assumptions above,
            you will be unable to continue.
          </p>
        </div>

      </div>
    </div>
  )
}
